module.exports = __webpack_public_path__ + "static/media/Geometrie.93dd8015.txt";